module.exports = __webpack_public_path__ + "static/media/american-sign-language-interpreting.3e8c0f12.svg";